class BannerHome {
	constructor() {
		this.animations = document.querySelectorAll(".sprite-anim");

		if (!this.animations) {
			return;
		}

		this.buildAnimations();
	}

	buildAnimations() {
		this.animations.forEach(canvas => {

			let context = canvas.getContext("2d"),
				img = new Image(),
				spriteWidth = canvas.dataset.spriteWidth,
				spriteHeight = canvas.dataset.spriteHeight,
				numRows = canvas.dataset.stepRow,
				numColumns = canvas.dataset.stepColumn,
				frameWidth = spriteWidth / numColumns,
				frameHeight = spriteHeight / numRows,
				maxFrame = canvas.dataset.stepCount - 1,
				currentFrame = 0;

			canvas.width = frameWidth;
			canvas.height = frameHeight;

			img.src = canvas.dataset.src;
			img.onload = function() {
				setInterval(() => {
					currentFrame++;

					if (currentFrame > maxFrame){
						currentFrame = 0;
					}

					let column = currentFrame % numColumns;
					let row = Math.floor(currentFrame / numColumns);

					context.clearRect(0, 0, canvas.width, canvas.height);
					context.drawImage(img, column * frameWidth, row * frameHeight, frameWidth, frameHeight, 0, 0, frameWidth, frameHeight);

				}, 42);
			};
		});
	}

}